import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19aa88c8")

_pushScopeId("data-v-19aa88c8")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { style: {"position":"absolute","bottom":"20px","right":"20px"} }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Navbar = _resolveComponent("Navbar")
  const _component_AppMain = _resolveComponent("AppMain")
  const _component_el_affix = _resolveComponent("el-affix")

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.classObj, "app-wrapper"]
  }, [
    (_ctx.classObj.mobile && _ctx.sidebar.opened)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "drawer-bg",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleClickOutside && _ctx.handleClickOutside(...args)))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, { class: "sidebar-container" }),
    _createVNode("div", {
      class: [{ hasTagsView: _ctx.showTagsView }, "main-container"]
    }, [
      _createVNode("div", {
        class: { 'fixed-header': _ctx.fixedHeader }
      }, [
        _createVNode(_component_Navbar),
        _hoisted_1
      ], 2),
      _createVNode(_component_AppMain),
      _createVNode(_component_el_affix, { offset: 100 }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ], 2)
  ], 2))
})